import React from 'react';
import { connect } from 'react-redux';
import { SECTION_TYPE_TEXT_COLUMNS_SINGLE_MEDIA } from '../../constants';
import {
    closeEditTextSectionColumnsSingleMedia,
    updateTextColumnSingleMediaSectionContents,
} from '../../actions';
import {
    selectImageSettingInTheSectionEditPopup,
    selectVideoSettingInTheSectionEditPopup,
    selectSectionSettingInTheSectionEditPopup,
    deleteSingleImageFromTheSectionEditPopup,
    updateTitleFieldInTheSectionEditPopup,
    updateBodyFieldInTheSectionEditPopup,
    updateSingleVideoUrlFieldInTheSectionEditPopup,
    updateInstructionsFieldInTheSectionEditPopup,
    updateSingleCroppedImageInTheSectionEditPopup,
    updateSingleImageMetaInTheSectionEditPopup,
    updateSingleThumbCroppedImageInTheSectionEditPopup,
    updateImageInTheSectionEditPopup,
    updateSingleImageCropRatioInTheSectionEditPopup,
} from '../../sections/actions';
import {
    fetchImageSettings,
    fetchVideoSettings,
    fetchSectionSettings,
} from '../../../pages/settings/thunks';
import { fetchImageRatios } from '../../../images/thunks';
import TextColumnsSingleMediaSectionEdit from './text_columns_single_media_section_edit';

class TextColumnsSingleMediaPopup extends React.Component {
    componentWillUpdate(nextProps) {
        if (
            nextProps.textSectionEditOpen === true &&
            this.props.textSectionEditOpen === false
        ) {
            if (!this.props.allImageSettings || this.props.allImageSettings.length === 0) {
                this.props.fetchImageSettings();
            }
            if (!this.props.allVideoSettings || this.props.allVideoSettings.length === 0) {
                this.props.fetchVideoSettings();
            }
            if (!this.props.allSectionSettings || this.props.allSectionSettings.length === 0) {
                this.props.fetchSectionSettings();
            }
            if (!this.props.imageRatios || this.props.imageRatios.length === 0) {
                this.props.fetchImageRatios();
            }
        }
    }

    render() {
        let textSectionImageSettings = this.props.allImageSettings.filter(
            (setting) =>
                Number(setting.section_type_id) ===
                SECTION_TYPE_TEXT_COLUMNS_SINGLE_MEDIA
        );

        let textSectionVideoSettings = this.props.allVideoSettings.filter(
            (setting) =>
                Number(setting.section_type_id) ===
                SECTION_TYPE_TEXT_COLUMNS_SINGLE_MEDIA
        );

        const sectionSettings = this.props.allSectionSettings.filter(
            setting => Number(setting.section_type_id) === SECTION_TYPE_TEXT_COLUMNS_SINGLE_MEDIA
        );

        return (
            <TextColumnsSingleMediaSectionEdit
                open={this.props.textSectionEditOpen}
                textSectionId={this.props.textSectionId}
                sectionTypeText={this.props.sectionTypeText}
                title={this.props.textSectionTitle}
                body={this.props.textSectionBody}
                instructions={this.props.textSectionInstructions}
                image={this.props.sectionImage}
                imageRatios={this.props.imageRatios.text}
                imageSettings={textSectionImageSettings}
                video={this.props.sectionVideo}
                videoSettings={textSectionVideoSettings}
                selectImageSetting={(selectedOptions, forSetting) => {
                    this.props.selectImageSetting(selectedOptions, forSetting);
                }}
                selectVideoSetting={(selectedOptions, forSetting) => {
                    this.props.selectVideoSetting(selectedOptions, forSetting);
                }}
                selectedImageSettings={this.props.selectedImageSettings}
                selectedVideoSettings={this.props.selectedVideoSettings}
                sectionSettings={sectionSettings}
                selectedSectionSettings={this.props.selectedSectionSettings}
                selectSectionSetting={this.props.selectSectionSetting}
                onUpdateTitleField={(title) =>
                    this.props.updateTextSectionTitleField(title)
                }
                onUpdateBodyField={(body) =>
                    this.props.updateTextSectionBodyField(body)
                }
                onUpdateInstructionsField={(instructions) =>
                    this.props.updateTextSectionInstructionsField(instructions)
                }
                onUpdateImageField={(images) =>
                    this.props.updateImageSectionFields(images[0])
                }
                onDeleteImageField={() =>
                    this.props.deleteImageFromSectionField()
                }
                onUpdateVideoUrlField={(id, url) =>
                    this.props.updateTextSectionVideoUrlField(id, url)
                }
                onCropImage={(image, imageUrlBlob, imageBlobObject) => {
                    this.props.updateCroppedImage(
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    );
                }}
                onCropThumbImage={(image, imageUrlBlob, imageBlobObject) => {
                    this.props.updateThumbCroppedImage(
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    );
                }}
                onImageMetaUpdate={(imageMeta) => {
                    this.props.updateImageMeta(imageMeta);
                }}
                onImageCropRatioUpdate={(cropRatioId) => {
                    this.props.updateImageCropRatio(cropRatioId);
                }}
                onHandleRequestDone={() =>
                    this.props.updateTextColumnSingleMediaSectionContents(
                        this.props.pageId,
                        this.props.textSectionId,
                        this.props.sectionData,
                        this.props.selectedImageSettings,
                        this.props.selectedVideoSettings,
                        this.props.selectedSectionSettings,
                    )
                }
                onHandleRequestClose={() =>
                    this.props.closeEditTextSectionColumnsSingleMedia()
                }
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        textSectionId: state.pageBuilderSectionPopup.sectionId,
        sectionData: state.pageBuilderSectionPopup.data,
        selectedImageSettings: state.pageBuilderSectionPopup.imageSettings,
        selectedVideoSettings: state.pageBuilderSectionPopup.videoSettings,
        selectedSectionSettings: state.pageBuilderSectionPopup.sectionSettings,
        textSectionEditOpen:
            state.pageBuilder.textColumnsSingleMediaSectionPopup.open,
        textSectionTitle: state.pageBuilderSectionPopup.data.title,
        textSectionBody: state.pageBuilderSectionPopup.data.body,
        textSectionInstructions:
            state.pageBuilderSectionPopup.data.instructions,
        textSectionPageId: state.pageBuilderSectionPopup.pageId,
        sectionImage: state.pageBuilderSectionPopup.data.image,
        sectionVideo: state.pageBuilderSectionPopup.data.video,
        imageRatios: state.images.ratios,
        allImageSettings: state.sectionsSettings.imageSettings,
        allVideoSettings: state.sectionsSettings.videoSettings,
        allSectionSettings: state.sectionsSettings.sectionSettings,
    };
}

export default connect(
    mapStateToProps,
    {
        selectImageSetting: selectImageSettingInTheSectionEditPopup,
        selectVideoSetting: selectVideoSettingInTheSectionEditPopup,
        deleteImageFromSectionField: deleteSingleImageFromTheSectionEditPopup,
        updateTextSectionTitleField: updateTitleFieldInTheSectionEditPopup,
        updateTextSectionBodyField: updateBodyFieldInTheSectionEditPopup,
        updateTextSectionVideoUrlField: updateSingleVideoUrlFieldInTheSectionEditPopup,
        updateTextSectionInstructionsField: updateInstructionsFieldInTheSectionEditPopup,
        updateCroppedImage: updateSingleCroppedImageInTheSectionEditPopup,
        updateThumbCroppedImage: updateSingleThumbCroppedImageInTheSectionEditPopup,
        updateImageMeta: updateSingleImageMetaInTheSectionEditPopup,
        updateImageCropRatio: updateSingleImageCropRatioInTheSectionEditPopup,
        selectSectionSetting: selectSectionSettingInTheSectionEditPopup,
        fetchSectionSettings,
        updateTextColumnSingleMediaSectionContents,
        closeEditTextSectionColumnsSingleMedia,
        fetchImageSettings,
        fetchVideoSettings,
        fetchImageRatios,
        updateImageSectionFields: updateImageInTheSectionEditPopup,
    }
)(TextColumnsSingleMediaPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/text_columns_single_media_popup.js